import styled from "styled-components";

import { FlexDiv } from "../../../../components/Atoms";

export const StyledHighlights = styled(FlexDiv)`
  gap: 16px;

  @media only screen and (max-width: 600px) {
    gap: 8px;
    padding: 24px;
  }
`;
